import axios from "axios";
import { siteSettings } from "../static";
import { uploadViaBunny } from "./uploadMedia";

export async function uploadImageToCloudinary(file, onUploadProgress) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", siteSettings.uploadPreset);

  const config = {};
  if (onUploadProgress) {
    config.onUploadProgress = (progressEvent) => {
      const progress = (progressEvent.loaded / progressEvent.total) * 100;
      onUploadProgress(Number(progress));
    };
  }

  const response = await uploadViaBunny(formData,
    config,
  );

  return response.data.secure_url;
}

export async function uploadToCloudinary(file, onUploadProgress) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", siteSettings.uploadPreset);

  const config = {};
  if (onUploadProgress) {
    config.onUploadProgress = (progressEvent) => {
      const progress = (progressEvent.loaded / progressEvent.total) * 100;
      onUploadProgress(Number(progress));
    };
  }

  const response = await uploadViaBunny(formData,
    config,
  );

  return response.data.secure_url;
}
